// extracted by mini-css-extract-plugin
module.exports = {"cartWrapper":"styles_cartWrapper__O3eEx","title":"styles_title__2kzWr"};